import * as THREE from "three";

export function addTextLabel({
  text,
  position,
  normal,
  ball,
  color = "#ffaa00",
  width = 2,
  lift = 0.05,
}) {
  console.log(
    "[addTextLabel] Adding label:",
    text,
    "to ball at position:",
    position,
  );
  const canvas = document.createElement("canvas");
  canvas.width = 1024;
  canvas.height = 512;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.font = "bold 200px Arial";
  ctx.fillStyle = color;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(text, canvas.width / 2, canvas.height / 2);

  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;
  texture.needsUpdate = true;

  const aspect = canvas.width / canvas.height;
  const height = width / aspect;

  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    side: THREE.DoubleSide,
  });

  const plane = new THREE.Mesh(
    new THREE.PlaneGeometry(width, height),
    material,
  );

  plane.position.copy(
    position.clone().add(normal.clone().multiplyScalar(lift)),
  );
  plane.lookAt(normal.clone());
  plane.rotateY(Math.PI);
  ball.add(plane);
}

export function makeCircleMarker(pos, color, ball) {
  console.log(
    "[makeCircleMarker] Adding marker at position:",
    pos,
    "color:",
    color,
  );
  const radius = 0.15;
  const geometry = new THREE.CircleGeometry(radius, 32);
  const material = new THREE.MeshBasicMaterial({
    color,
    side: THREE.DoubleSide,
  });
  const marker = new THREE.Mesh(geometry, material);
  marker.position.copy(pos);
  const normal = pos.clone().normalize();
  marker.lookAt(pos.clone().add(normal));
  ball.add(marker);
}

export function drawFingerRing(
  ball,
  center,
  radiusInches,
  ballRadius,
  arcOffset = 0.005,
  color = 0xffffff,
) {
  const theta = radiusInches / ballRadius;
  const normal = center.clone().normalize();

  const tangent = new THREE.Vector3(0, 1, 0);
  if (Math.abs(normal.dot(tangent)) > 0.99) tangent.set(1, 0, 0);

  const ringAxis = new THREE.Vector3()
    .crossVectors(normal, tangent)
    .normalize();

  const startPoint = center
    .clone()
    .applyAxisAngle(ringAxis, -theta)
    .normalize()
    .multiplyScalar(ballRadius + arcOffset);

  const ringPoints = [];
  const segments = 128;
  for (let i = 0; i <= segments; i++) {
    const angle = (2 * Math.PI * i) / segments;
    const point = startPoint
      .clone()
      .applyAxisAngle(normal, angle)
      .normalize()
      .multiplyScalar(ballRadius + arcOffset);
    ringPoints.push(point);
  }

  const MeshLine = require("meshline").MeshLineGeometry;
  const MeshLineMaterial = require("meshline").MeshLineMaterial;
  const line = new MeshLine();
  line.setPoints(ringPoints);
  const material = new MeshLineMaterial({
    color: new THREE.Color(color),
    lineWidth: 0.05,
  });

  const mesh = new THREE.Mesh(line, material);
  ball.add(mesh);
}
